enum FlowModelType {
  Workflow = 0,
  ProcessMap = 1
}

export default FlowModelType;
